/**
 * customsirge_category_grid.js — category tile expand/collapse.
 *
 * Drives the open tile by moving the existing `customsirge-cattile--featured` class
 * (which already carries all of the expanded styling) instead of CSS :hover.
 *
 * Desktop (fine pointer): hovering a tile opens it. The class is never cleared on
 * mouseleave, so the LAST hovered tile stays open — hovering the empty space beside
 * the collapsed tiles can no longer collapse every tile.
 *
 * Touch/mobile: the first tap opens a collapsed tile instead of following its link;
 * tapping the already-open tile (or its CTA) navigates normally.
 */
(function () {
  var ACTIVE = 'customsirge-cattile--featured';

  function getTiles(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll('.customsirge-cattile'));
  }

  function setActive(grid, tile) {
    getTiles(grid).forEach(function (t) {
      t.classList.toggle(ACTIVE, t === tile);
    });
  }

  function initGrid(grid) {
    if (grid.dataset.customsirgeCatgridReady === 'true') return;
    grid.dataset.customsirgeCatgridReady = 'true';

    var tiles = getTiles(grid);
    if (!tiles.length) return;

    // Guarantee exactly one open tile at all times (block-flagged one, else the first).
    setActive(grid, grid.querySelector('.' + ACTIVE) || tiles[0]);

    var canHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    tiles.forEach(function (tile) {
      tile.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        setActive(grid, tile);
      });

      tile.addEventListener('click', function (event) {
        // Already open -> let the click through so the tile/CTA follows its link.
        if (tile.classList.contains(ACTIVE)) return;
        event.preventDefault();
        setActive(grid, tile);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-customsirge-catgrid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', init);
})();
